// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__iQf7k","colMaxWidth":"Table_colMaxWidth__1OsIY"};